import React from 'react';
import { FN117 } from '../../../services/pwn201Api';

interface Props {
  totalCount: number;
  rows: FN117[];
  isEditing: boolean;
  onAdd: () => void;
  onDelete: (idx: number) => void;
  onChange: (idx: number, field: keyof FN117, value: unknown) => void;
}

const FILE_TYPE_OPTIONS = [
  { value: 1, label: '1-圖片' },
  { value: 2, label: '2-文件' },
  { value: 3, label: '3-試算表' },
  { value: 4, label: '4-PDF' },
  { value: 5, label: '5-其他' },
];

const TabAttachments: React.FC<Props> = React.memo(({ totalCount, rows, isEditing, onAdd, onDelete, onChange }) => (
  <div className="pwn201-tab-content">
    <div style={{ marginBottom: 12 }}>
      <span>總項數: <strong>{totalCount}</strong></span>
    </div>
    {isEditing && (
      <div className="pwn201-tab-toolbar">
        <button onClick={onAdd} className="btn-add">+ 新增附件</button>
      </div>
    )}
    <table className="pwn201-grid">
      <thead>
        <tr>
          <th>序號</th>
          <th>附件名稱</th>
          <th>檔案類型</th>
          {isEditing && <th>操作</th>}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx}>
            <td>{row.fn117_02}</td>
            <td>
              <input
                value={row.fn117_11}
                onChange={(e) => onChange(idx, 'fn117_11', e.target.value)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <select
                value={row.fn117_21}
                onChange={(e) => onChange(idx, 'fn117_21', parseInt(e.target.value))}
                disabled={!isEditing}
              >
                {FILE_TYPE_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </td>
            {isEditing && (
              <td>
                <button onClick={() => onDelete(idx)} className="btn-delete">刪除</button>
              </td>
            )}
          </tr>
        ))}
        {rows.length === 0 && (
          <tr><td colSpan={isEditing ? 4 : 3} style={{ textAlign: 'center', color: '#999' }}>無資料</td></tr>
        )}
      </tbody>
    </table>
  </div>
));

export default TabAttachments;
